import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import type { AdminSettingsStatusResult } from "@/lib/admin-settings-status";

export function AdminSettingsHeader({
  status,
}: {
  status: AdminSettingsStatusResult | null;
}) {
  const allReady = status ? status.warningCount === 0 : false;

  return (
    <header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        <h1
          className="text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Postavke platforme
        </h1>
        <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Jedno mjesto za konfiguraciju platforme: cijene, naplata, onboarding terapeuta,
          katalog i komunikacija. Operativni queue-ovi ostaju u glavnom admin meniju.
        </p>
      </div>
      {status && (
        <span
          className={cn(
            "inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold ring-1",
            allReady
              ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
              : "bg-amber-50 text-amber-700 ring-amber-200",
          )}
        >
          {allReady ? <CheckCircle className="size-3.5" weight="fill" /> : <WarningCircle className="size-3.5" />}
          {allReady ? "Sve konfigurisano" : `${status.warningCount} upozorenja`}
        </span>
      )}
    </header>
  );
}
